window.process = window.process || { env: {} };
import React from "react";
import ReactDOM from "react-dom";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import "assets/plugins/nucleo/css/nucleo.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "assets/scss/argon-dashboard-react.scss";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import App from "./App";
import { Provider } from "react-redux";
import store from "./store/index";
import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";

if (process.env.NODE_ENV === "production") {
  Sentry.init({
    dsn: "https://3e18271bafbc6919dbbfd8062c0c2d68@o4507571489210368.ingest.de.sentry.io/4508992536707152",
    integrations: [new BrowserTracing()],
    tracesSampleRate: 1.0
  });
}

ReactDOM.render(
  <>
    <Provider store={store}>
      <Sentry.ErrorBoundary
        fallback={
          <div className="d-flex flex-column align-items-center justify-content-center text-danger py-10">
            <div className="fw-bold text-center fs-1">
              Something went wrong. Please try again later. 🚨
            </div>
          </div>
        }
      >
        <ToastContainer />
        <App />
      </Sentry.ErrorBoundary>
    </Provider>
  </>,
  document.getElementById("root")
);
serviceWorkerRegistration.register();
